export class Classification {
  id: number;
  description: string;
  quantity: number;

  static fromJson(json: any): Classification {
    var temp = new Classification();
    temp.id = json.ID;
    temp.description = json.CLASNAME;
    temp.quantity = json.QUANTITY;
    return temp;
  }

}
